import React, {createContext, useContext, useMemo, useState} from 'react';
import {useDeviceDetection} from '@/hooks/useDeviceDetection';
import {getUserLoginId} from '@/utils/main';

type DeviceType = 'pc' | 'mobile';

interface HelpContextType {
  userId: string;
  isMobile: boolean;
  deviceType: DeviceType;
  setUserId: (id: string) => void;
}

const HelpContext = createContext<HelpContextType>({
  userId: '',
  isMobile: false,
  deviceType: 'pc',
  setUserId: () => {},
});

export const useHelpContext = () => useContext(HelpContext);

interface HelpProviderProps {
  children: React.ReactNode;
  deviceTypeFromParent?: DeviceType;
}

export const HelpProvider = ({
  children,
  deviceTypeFromParent,
}: HelpProviderProps) => {
  const detectedDeviceType = useDeviceDetection('userAgent');
  const [userId, setUserId] = useState(getUserLoginId());

  /* 상위에서 내려준 값이 있으면 그걸, 없으면 감지값 사용 */
  const deviceType = deviceTypeFromParent ?? detectedDeviceType;
  const isMobile = deviceType === 'mobile';

  const value = useMemo(
    () => ({
      userId,
      isMobile,
      deviceType,
      setUserId,
    }),
    [userId, deviceType, isMobile],
  );

  return <HelpContext.Provider value={value}>{children}</HelpContext.Provider>;
};
